export default {
    NETWORK_NAME_SINGULAR: 'Group',
    NETWORK_NAME_PLURAL: 'Groups',
}